import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/Logo-L';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-charcoal text-ivory sticky top-0 z-50 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-2">
          <Logo className="h-14 w-auto" />
        </Link>

        {/* Hamburger button */}
        <button
          className="sm:hidden flex items-center px-3 py-2 border rounded text-ivory border-ivory"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <svg
            className="h-6 w-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            {menuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>

        {/* Desktop nav */}
        <ul className="hidden sm:flex space-x-8 items-center">
          <li>
            <Link to="/" className="text-base font-medium hover:text-copper transition-colors duration-200">Home</Link>
          </li>
          <li>
            <Link to="/listings" className="text-base font-medium hover:text-copper transition-colors duration-200">Listings</Link>
          </li>
          <li>
            <Link to="/add" className="text-base font-medium hover:text-copper transition-colors duration-200">Add Listing</Link>
          </li>
          <li>
            <Link to="/login" className="bg-copper text-ivory px-4 py-2 rounded-md font-medium hover:bg-copper-dark transition-colors duration-200">Sign In</Link>
          </li>
        </ul>
      </div>

      {/* Mobile overlay menu */}
      <div
        className={`sm:hidden absolute top-full left-0 w-full bg-charcoal text-ivory shadow-md transition-all duration-300 ease-in-out ${
          menuOpen ? 'max-h-96 opacity-100 visible' : 'max-h-0 opacity-0 invisible'
        } overflow-hidden z-40`}
      >
        <ul className="flex flex-col items-start p-4 space-y-2">
          <li>
            <Link to="/" onClick={() => setMenuOpen(false)} className="block py-2 text-base font-medium hover:text-copper">Home</Link>
          </li>
          <li>
            <Link to="/listings" onClick={() => setMenuOpen(false)} className="block py-2 text-base font-medium hover:text-copper">Listings</Link>
          </li>
          <li>
            <Link to="/add" onClick={() => setMenuOpen(false)} className="block py-2 text-base font-medium hover:text-copper">Add Listing</Link>
          </li>
          <li>
            <Link to="/login" onClick={() => setMenuOpen(false)} className="block bg-copper text-ivory px-4 py-2 rounded-md font-medium hover:bg-copper-dark w-full text-center">Sign In</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
